var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DxButton',{staticClass:"record-print-btn",attrs:{"icon":"trash"},on:{"click":_vm.onItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }